import { AppConfigProvider } from '@root/app/app.config.provider';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PermissionList, Permission, PermissionAccessLevel, isAccessLevel, isPermission } from './authorization';

const SETTINGS_KEY = 'liqlastSelectedItems';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  public role;
  private permissionsForUser: PermissionList;
  private apiUser;

  constructor(private http: HttpClient, private appConfig: AppConfigProvider) {
    this.appConfig.environment.subscribe(env => {
      this.apiUser = env.API.USERAPI;
    });
  }

  public getPermission(section: Permission): PermissionAccessLevel {
    return this.permissionsForUser ? this.permissionsForUser[section] : null;
  }

  public loadPermissionsIntoApp(levelid): Promise<PermissionList> {
    const url = `${this.apiUser}/api/permissions/${levelid}`;
    const result = this.http.get(url).toPromise();
    return result.then((permissionList: any[]) => {
      const parsedPermissions = this.permissionBuilder(permissionList);
      this.permissionsForUser = parsedPermissions;
      return this.permissionsForUser;
    });
  }

  private permissionBuilder(permissionApiResponse: any[]): PermissionList {
    const result = {} as PermissionList;
    permissionApiResponse.forEach(item => {
      if (isPermission(item.permission_name) && isAccessLevel(item.access)) {
        result[item.permission_name] = item.access;
      } else {
        console.warn('An uncatalogued permission is in the database. Please contact system administrator. \n', item);
      }
    });

    return result;
  }

  public saveTabsToSessionStorage(lastSelectedItemsRouterLinks) {
    try {
      const jsonString = JSON.stringify(lastSelectedItemsRouterLinks);
      sessionStorage.setItem(SETTINGS_KEY, jsonString);
    } catch (error) {
      // console.warn(`Error saving to Local storage`, error);
    }
  }

  public getTabsFromSessionStorage() {
    return sessionStorage.getItem(SETTINGS_KEY);
  }

  public clearTabsFromSessionStorage() {
    sessionStorage.removeItem(SETTINGS_KEY);
  }
}
